<div class="shape-list-container">
  <ng-container *ngIf="!isObjectEnabledProject">
    <!--Force tag editor to reinitialize every time when the focused shape store is changed to avoid-->
    <!--race condition that tag editor store sets wrong value coz copy from shape store might have not -->
    <!--completed yet-->
    <h3-objectless-shape-list
      [hidden]="shapeListHidden$ | async"
      [hoverButtonTemplate]="hoverButtonTemplate"
      [staticButtonTemplate]="staticButtonTemplate"
    >
    </h3-objectless-shape-list>
    <h3-objectless-tag-editor
      [hidden]="tagEditorHidden$ | async"
      *ngFor="let shape of focusedStoreChanged$ | async"
    ></h3-objectless-tag-editor>
    <h3-shape-filter [hidden]="shapeFiltersHidden$ | async"></h3-shape-filter>
  </ng-container>
  <h3-side-panel
    *ngIf="isObjectEnabledProject && (displayObjectList$ | async)"
  ></h3-side-panel>
</div>

<ng-template #hoverButtonTemplate let-shapeStore="shapeStore">
  <h3-edit-tags-button [shapeStore]="shapeStore"></h3-edit-tags-button>
</ng-template>
<ng-template #staticButtonTemplate let-shapeStore="shapeStore">
  <h3-toggle-shape-visibility-button
    *ngIf="isMultiFrame"
    [shapeStore]="shapeStore"
  ></h3-toggle-shape-visibility-button>
</ng-template>
